import React from 'react';
import SVG from 'react-inlinesvg';
import { Link, useLocation } from 'react-router-dom';
import home from '/src/assets/img/home.svg';
import help from '/src/assets/img/help-web-button.svg';
import qr from '/src/assets/img/qr-code.svg';
import chat from '/src/assets/img/chat-balloon.svg';
export default function BottomNav(){
  const { pathname } = useLocation();
  return (
    <nav className="tabbar">
      <Link className={pathname==='/' ? 'active' : ''} to="/" aria-label="Кабинет">
        <SVG className={'nav-icon'} src={home}/> Кабинет
      </Link>
      <Link className={pathname==='/access' ? 'active' : ''} to="/access" aria-label="Доступы">
        <SVG className={'nav-icon'} src={qr}/> Доступы
      </Link>
      <Link className={pathname==='/instructions' ? 'active' : ''} to="/instructions" aria-label="Инструкции">
        <SVG className={'nav-icon'} src={help}/> Инструкции
      </Link>
      <Link className={pathname==='/support' ? 'active' : ''} to="https://t.me/altavpn_supp" aria-label="Инструкции">
        <SVG className={'nav-icon'} src={chat}/> Поддержка
      </Link>

    </nav>
  );
}
